import React, { FC, useState } from 'react';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import { Document, pdfjs, Page } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface IPDFViewer {
  source: string;
}

const PDFViewer: FC<IPDFViewer> = ({ source }) => {
  const [pages, setPages] = useState(0);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setPages(numPages);
  };

  return (
    <div>
      <Document onLoadSuccess={onDocumentLoadSuccess} file={source}>
        {Array.from(new Array(pages)).map((_, index) =>
          (
            <Page key={_} pageNumber={index + 1} />
          ))}
      </Document>
    </div>
  );
};

export default PDFViewer;
